import React from 'react'

const Header = () => {
  return (
    <div className='text-center pb-8'>
      <h1 className='text-2xl md:text-3xl font-bold pb-1'>Image Gallery Task</h1>
      <p className='text-sm'>Simplifying image with upload, select, and delete features.</p>
    </div>
  )
}

export default Header